export default __webpack_public_path__ + "086aeb49fbffe06da3e278c2bf3ab54b.png";